import React from 'react';
import { PERMISSIONS } from 'constants/permissions';
import { Col, EditableInfoComponent, Row } from 'components';
import { SpecialPricingRulesIcon } from 'components/common/icons';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { useSpecialPricingRules } from './useSpecialPricingRules';
import { SpecialPricingRulesAddUpdateModal } from './addEdit';
import { SpecialPricingRule } from './specialPricingRule';
import { DeleteModal } from './delete';

export const SupplierSpecialPricingRules = React.memo(() => {
  const { hasAccess } = useAccessControl();
  const {
    addModalState,
    onAddModalStateChange,
    pricingRules,
    isDeleteModalOpen,
    dataToEdit,
    onHandleDelete,
    onDeleteModalClose,
  } = useSpecialPricingRules();
  return (
    <>
      <EditableInfoComponent
        title={'Special Pricing Rules'}
        icon={<SpecialPricingRulesIcon />}
        creatable={hasAccess(PERMISSIONS.suppliers.special_pricing_rules.write)}
        editable={false}
        onAdd={onAddModalStateChange}
      />
      <Row>
        {pricingRules.map((_pricingRule: Record<string, any>) => (
          <Col key={_pricingRule.id} span={24}>
            <SpecialPricingRule data={_pricingRule} onHandleDelete={onHandleDelete} />
          </Col>
        ))}
      </Row>
      <SpecialPricingRulesAddUpdateModal modalState={addModalState} onModalStateChange={onAddModalStateChange} />
      <DeleteModal openModal={isDeleteModalOpen} onDeleteModalClose={onDeleteModalClose} dataToDelete={dataToEdit} />
    </>
  );
});
